export const SwitchStyle = (color: string): void => {
  const styleArr: string[] = ["blueBack", "greenBack", "orangeBack", "redBack"];
  const inactiveArr = styleArr.filter((back) => back !== color);
  inactiveArr.forEach((item) => document.body.classList.remove(item));
  document.body.classList.add(color);
};
